import { textStyles } from '@maestro/styles';
import styled from 'styled-components';

export const Warning = styled.div`
  ${textStyles.body.b12m}
  color: ${({ theme }) => theme.colors.warning};
`;
